import type { PriceBreakdown as Breakdown } from '@brandonstrong/types';
import { money, shortDate } from '../lib/format';

export function PriceBreakdown({
  price,
  showNights = true,
}: {
  price: Breakdown;
  showNights?: boolean;
}) {
  return (
    <dl className="flex flex-col gap-1.5 text-sm">
      {showNights &&
        price.nightly.map((n) => (
          <div key={n.date} className="flex justify-between text-ink-400">
            <dt>{shortDate(n.date)}</dt>
            <dd>{money(n.rate)}</dd>
          </div>
        ))}
      <div className="flex justify-between border-t border-night-700 pt-2 text-ink-200">
        <dt>
          Room subtotal ({price.nights} night{price.nights === 1 ? '' : 's'})
        </dt>
        <dd>{money(price.subtotal)}</dd>
      </div>
      {price.fees.map((fee) => (
        <div key={fee.name} className="flex justify-between text-ink-400">
          <dt>
            {fee.name} {fee.per === 'night' ? `(${money(fee.amount)} × ${price.nights})` : ''}
          </dt>
          <dd>{money(fee.total)}</dd>
        </div>
      ))}
      {/* $299 is the whole price; the tax line only shows if a rate is ever set. */}
      {Number(price.taxRate) > 0 && (
        <div className="flex justify-between text-ink-400">
          <dt>Tax ({Number(price.taxRate)}%)</dt>
          <dd>{money(price.taxAmount)}</dd>
        </div>
      )}
      <div className="flex justify-between border-t border-night-700 pt-2 text-lg font-semibold text-ink-50">
        <dt>Total</dt>
        <dd>{money(price.total)}</dd>
      </div>
    </dl>
  );
}
